// extracted by mini-css-extract-plugin
module.exports = {"notif":"ShareButton_notif__B2W_v","show":"ShareButton_show__oIi7j"};